var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"va-pro-badge"},[_vm._v("PRO")])
}
var staticRenderFns = []

export { render, staticRenderFns }